import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import FieldLabelWrapper from '../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../components/Form/Field'

import { tikTokPixelsSelector } from '../../../../../../../modules/selectors/tikTokConstants'

import { OBJECTIVE } from '../../../../../../Multiplatform/CampaignForms/fields'
import { objectivesList } from '../../fields'
import { LEAD_GENERATION, WEB_CONVERSIONS } from '../../../../../../../constants/campaigns'

const CampaignObjectiveField = ({ formik }) => {
  const { t } = useTranslation()

  const tikTokPixels = useSelector(tikTokPixelsSelector)

  const formattedObjectivesList = useMemo(() => {
    return objectivesList.map(option => {
      const isDisabled = (option.value === LEAD_GENERATION || option.value === WEB_CONVERSIONS) && !tikTokPixels.length
      return {
        ...option,
        isDisabled: isDisabled
      }
    })
  }, [tikTokPixels.length])

  return (
    <FieldLabelWrapper label={t('Campaign goal')}>
      <p>{t('To upload the ad to a new campaign, please select the campaign optimisation goal.')}</p>
      <Field
        name={OBJECTIVE}
        label="Goal"
        placeholder="Select goal..."
        formik={formik}
        options={formattedObjectivesList}
      />
    </FieldLabelWrapper>
  )
}

export default CampaignObjectiveField
